import { useQuery } from '@apollo/client';

import ProgramMembershipsByUserIdAndIncludeInvitationsQuery from 'bundles/enterprise-legacy-learner-home/components/single-program/queries/ProgramMembershipsByUserIdAndIncludeInvitations.graphql';
import type {
  ProgramMembershipsByUserIdAndIncludeInvitationsQuery as ProgramMembershipsByUserIdAndIncludeInvitationsQueryData,
  ProgramMembershipsByUserIdAndIncludeInvitationsQueryVariables,
} from 'bundles/enterprise-legacy-learner-home/components/single-program/queries/__generated__/ProgramMembershipsByUserIdAndIncludeInvitations';

export type PropsForWithHasMultipleProgramProps = {
  userId: number | string;
  thirdPartyOrganizationId?: string;
};

export const useHasMultipleProgramProps = ({
  userId,
  thirdPartyOrganizationId,
}: PropsForWithHasMultipleProgramProps) => {
  const { data } = useQuery<
    ProgramMembershipsByUserIdAndIncludeInvitationsQueryData,
    ProgramMembershipsByUserIdAndIncludeInvitationsQueryVariables
  >(ProgramMembershipsByUserIdAndIncludeInvitationsQuery, {
    skip: !userId,
    variables: {
      userId: Number(userId),
      includeInvitations: false,
    },
  });

  const programMemberships = data?.ProgramMemberships?.queryProgramMembershipsByUserIdAndIncludeInvitations?.edges
    ?.map((edge) => edge?.node)
    .filter(Boolean);
  const programMembershipsWithinOrg = programMemberships?.filter(
    (programMembership) => programMembership?.program?.naptimeThirdPartyOrganization?.id === thirdPartyOrganizationId
  );

  return {
    hasMultipleProgramsInOrg: Number(programMembershipsWithinOrg?.length) > 1,
  };
};

export default useHasMultipleProgramProps;
